var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.37418 8.22904C1.31863 8.07941 1.31863 7.91482 1.37418 7.7652C1.91512 6.45357 2.83333 5.33209 4.01242 4.54294C5.1915 3.7538 6.57836 3.33252 7.99716 3.33252C9.41596 3.33252 10.8028 3.7538 11.9819 4.54294C13.161 5.33209 14.0792 6.45357 14.6201 7.7652C14.6757 7.91482 14.6757 8.07941 14.6201 8.22904C14.0792 9.54067 13.161 10.6621 11.9819 11.4513C10.8028 12.2404 9.41596 12.6617 7.99716 12.6617C6.57836 12.6617 5.1915 12.2404 4.01242 11.4513C2.83333 10.6621 1.91512 9.54067 1.37418 8.22904Z",
    stroke: "#9810FA",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99734 9.99663C9.10151 9.99663 9.99663 9.10151 9.99663 7.99734C9.99663 6.89316 9.10151 5.99805 7.99734 5.99805C6.89316 5.99805 5.99805 6.89316 5.99805 7.99734C5.99805 9.10151 6.89316 9.99663 7.99734 9.99663Z",
    stroke: "#9810FA",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.7ac2fdc7ab67f1cdd56aa685a2ee3c69.svg";
export { ForwardRef as ReactComponent };